(function() {
  'use strict';

  angular.module('crewProfile').controller('ExclusionViolationPopupCtrl',
    ExclusionViolationPopupCtrl);

  function ExclusionViolationPopupCtrl($uibModalInstance, modalParams) {

    var vm = this;
    vm.model = {
      airportExclusionViolation : modalParams.violatedAirportList || [],
      crewExclusionViolation : modalParams.violatedCrewList || [],
      airportExclusionString : (modalParams.violatedAirportList || []).join(', '),
      crewExclusionString : (modalParams.violatedCrewList || []).join(', '),
      // infoOnly = true means save already happened, just showing info (no confirm button)
      infoOnly : modalParams.infoOnly === true,
      // isInclusion = true when triggered from inclusion save (different title/message)
      isInclusion : modalParams.isInclusion === true
    };

    vm.onConfirmClick = function () {
      $uibModalInstance.close('CONFIRM');
    };

    vm.onCancelClick = function () {
      $uibModalInstance.close('CANCEL');
    };

    vm.onCloseClick = function () {
      $uibModalInstance.close('CLOSE');
    };
  }

}());
